export default "__VITE_ASSET__CVeqHM9y__"